import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeDiscoGuideFields {
  subscriptionType: EntryFieldTypes.Symbol<'Maths' | 'Reading'>
  title: EntryFieldTypes.Symbol
  description?: EntryFieldTypes.Text
  cover: EntryFieldTypes.AssetLink
  file: EntryFieldTypes.AssetLink
  domains: EntryFieldTypes.Array<
    EntryFieldTypes.Symbol<'all' | 'au' | 'ca' | 'cn' | 'in' | 'int' | 'kr' | 'nz' | 'th' | 'uk' | 'us' | 'za'>
  >
  product?: EntryFieldTypes.Symbol<'fast_phonics' | 'mathseeds' | 'reading_eggs' | 'reading_eggspress'>
}

export type TypeDiscoGuideSkeleton = EntrySkeletonType<TypeDiscoGuideFields, 'discoGuide'>
export type TypeDiscoGuide<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeDiscoGuideSkeleton,
  Modifiers,
  Locales
>

export function isTypeDiscoGuide<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeDiscoGuide<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'discoGuide'
}

export type TypeDiscoGuideWithoutLinkResolutionResponse = TypeDiscoGuide<'WITHOUT_LINK_RESOLUTION'>
export type TypeDiscoGuideWithoutUnresolvableLinksResponse = TypeDiscoGuide<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeDiscoGuideWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> = TypeDiscoGuide<
  'WITH_ALL_LOCALES',
  Locales
>
export type TypeDiscoGuideWithAllLocalesAndWithoutLinkResolutionResponse<Locales extends LocaleCode = LocaleCode> =
  TypeDiscoGuide<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeDiscoGuideWithAllLocalesAndWithoutUnresolvableLinksResponse<Locales extends LocaleCode = LocaleCode> =
  TypeDiscoGuide<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
